import lodash from "lodash";
import { GetFormSchemaPath } from "./GetFormSchemaPath";
import { GetUISchemaPath } from "./GetUISchemaPath";

export const GetFormSchemaItem = (itemID: string, objectToGet: any) => {
  const findItemPath = GetFormSchemaPath(itemID, objectToGet);
  return lodash.get(objectToGet.formSchema, findItemPath);
};

export const GetUIFormSchemaItem = (itemID: string, objectToGet: any) => {
  const findItemPath = GetFormSchemaPath(itemID, objectToGet);
  const findUIItemPath = GetUISchemaPath(findItemPath);
  return lodash.get(objectToGet.uiSchema, findUIItemPath);
};
